import axiosInterceptorInstance from "../../../utils/axios.interceptor";

export const fetchPlanNames = async (signal: AbortSignal) => {
  const res = await axiosInterceptorInstance.get(`/dashboard/ThaPlanName`, {
    signal,
  });
  return JSON.parse(res.data.body)?.Data || [];
};

export const fetchCohortReport = async (payload: any, signal: AbortSignal) => {
  const res = await axiosInterceptorInstance.post(
    `/dashboard/THACohortReport`,
    payload,
    { signal }
  );
  return JSON.parse(res.data.body)?.Data || [];
};
